/**
 * Loud trace helper — filter DevTools by: `[modamai-debug]`
 *
 * Logs every call (dev + prod) so staging builds still show traces.
 * To silence temporarily: sessionStorage.setItem('MODAMAI_DEBUG','0'); location.reload()
 */
export function modamaiTrace(tag, data) {
  try {
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('MODAMAI_DEBUG') === '0')
      return;
  } catch {
    /* ignore */
  }
  const stamp = `[modamai-debug] ${tag}`;
  // eslint-disable-next-line no-console
  if (data !== undefined) console.log(stamp, data);
  else console.log(stamp);
}
